import React from "react";
import { Link } from "react-router-dom";
import { filterByLanguage } from "../helpingFunctions/utils";
import OptimizedImage from "./ΟptimizedImage";
const stripHtml = (html) => {
  if (!html) return "";
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

const ReviewGrid = ({ title, reviews }) => {
  if (!reviews || reviews.length === 0) return null;

  const featured = reviews[0];
  const others = reviews.slice(1, 5);

  return (
    <section className="reviews-section bg-light py-5">
      <div className="container">
        <h2 className="text-dark fw-bold border-bottom border-2 border-dark d-inline-block mb-4 px-2">
          {title}
        </h2>

        <div className="row">
          {/* Featured Review */}
          <div className="col-md-8 mb-4 mb-md-0 position-relative">
            <div className="position-relative">
              <OptimizedImage
                src={featured.mainImageUrl}
                alt={featured.title}
                className="img-fluid w-100 rounded"
                style={{ height: "420px", objectFit: "cover" }}
              />
              <span
                className="position-absolute top-0 start-0 bg-dark text-white px-2 py-1 small"
                style={{ borderBottomRightRadius: "4px" }}
              >
                Review
              </span>
            </div>

            <div className="mt-3 text-dark">
              <Link
                to={`/articles/${featured.id}`}
                className="text-decoration-none"
              >
                <h3 className="fw-bold text-dark hover-text-danger">
                  {featured.title}
                </h3>
              </Link>
              <p className="text-muted small mb-2">
                {featured.createdAt?.toDate().toLocaleDateString("el-GR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </p>
              <p className="text-secondary" style={{ maxWidth: "95%" }}>
                {stripHtml(featured.content)?.slice(0, 220)}...
              </p>
              <div
                className="position-absolute bottom-0 end-0 bg-dark text-white px-2 py-1 d-flex align-items-center rounded-start"
                style={{ fontSize: "0.85rem" }}
              >
                <i className="bi bi-chat-dots me-1"></i> 0
              </div>
            </div>

            {/* Pagination */}
            <div className="mt-4">
              <button className="btn btn-outline-secondary btn-sm me-2">
                ◄
              </button>
              <button className="btn btn-outline-secondary btn-sm">►</button>
            </div>
          </div>

          {/* Side reviews */}
          <div className="col-md-4">
            {others.map((rev) => (
              <div
                key={rev.id}
                className="d-flex align-items-center mb-3 border-bottom pb-2"
              >
                <Link to={`/articles/${rev.id}`}>
                  <img
                    src={rev.mainImageUrl}
                    alt={rev.title}
                    className="img-fluid me-3 rounded"
                    style={{
                      width: "100px",
                      height: "70px",
                      objectFit: "cover",
                    }}
                  />
                </Link>
                <div>
                  <Link
                    to={`/articles/${rev.id}`}
                    className="text-dark text-decoration-none"
                  >
                    <h6 className="fw-semibold mb-1">{rev.title}</h6>
                  </Link>
                  <p className="text-muted small mb-0">
                    {rev.createdAt?.toDate().toLocaleDateString("el-GR", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const ReviewSection = ({ reviews }) => {
  if (!reviews || reviews.length === 0)
    return (
      <div className="text-center py-5 text-white">
        Δεν υπάρχουν reviews προς το παρόν.
      </div>
    );

  const greekReviews = filterByLanguage(reviews, "el");
  const englishReviews = filterByLanguage(reviews, "en");

  return (
    <>
      <ReviewGrid title="REVIEWS (GR)" reviews={greekReviews} />
      <ReviewGrid title="REVIEWS (EN)" reviews={englishReviews} />
    </>
  );
};

export default ReviewSection;
